import type { Notification } from '../types';
import { supabase, SUPABASE_ANON_KEY, SUPABASE_URL } from './supabaseClient';

export async function sendAccessRequestAdminEmail(notification: Notification): Promise<void> {
  const { data: { session } } = await supabase.auth.getSession();
  const accessToken = session?.access_token;
  if (!accessToken) throw new Error('Authentication required to send admin email notifications.');

  const response = await fetch(`${SUPABASE_URL}/functions/v1/access-request-admin-email`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      apikey: SUPABASE_ANON_KEY,
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      notificationId: notification.id,
      requesterId: notification.requesterId,
      requesterName: notification.requesterName,
      toolName: notification.toolName,
      accessReason: notification.accessReason,
      accessNeededBy: notification.accessNeededBy,
    }),
  });

  const payload = await response.json();
  if (!response.ok) {
    throw new Error(payload?.error || 'Failed to send admin access request email.');
  }
}

export async function sendTrainingReminderEmail(input: {
  employeeId: string;
  curriculumName: string;
  toolName: string;
}): Promise<void> {
  const { data: { session } } = await supabase.auth.getSession();
  const accessToken = session?.access_token;
  if (!accessToken) throw new Error('Authentication required to send training reminders.');

  const response = await fetch(`${SUPABASE_URL}/functions/v1/training-reminder-email`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      apikey: SUPABASE_ANON_KEY,
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      employeeId: input.employeeId,
      curriculumName: input.curriculumName,
      toolName: input.toolName,
    }),
  });

  const payload = await response.json();
  if (!response.ok) {
    throw new Error(payload?.error || 'Failed to send training reminder email.');
  }
}
